import React from "react";
import { withStyles } from "@material-ui/core/styles";
const styles = (theme) => ({
  container: {
    display: "flex",
    backgroundColor: theme.AppBGColor,
    opacity: 0.6,
    marginTop: 10,
  },
  label: {
    color: theme.TextColor,
    fontSize: theme.textFontSize,
    fontWeight: 500,
    lineHeight: "19px",
    textTransform: "uppercase",
  },
});

const PaymentHeader = ({ classes, label }) => (
  <div className={classes.container}>
    <span className={classes.label}>{label}</span>
  </div>
);

export default withStyles(styles)(PaymentHeader);
